import {SlotsSettingsDto, UpdateCabinetSlotsSettingsRq} from "@/types/slots";
import {format} from "date-fns";

//Mapping from SlotsSettingsDto to UpdateCabinetSlotsSettingsRq
export function mapToUpdateCabinetSlotsSettingsRq(from: SlotsSettingsDto): UpdateCabinetSlotsSettingsRq {
    const exceptions = from.exceptions.map(date => format(date, "yyyy-MM-dd").toString())
    return  {
        timeZone: from.timeZone,
        monday: from.monday
            //Sorting by time
            .toSorted((a, b) => a.timeStart.localeCompare(b.timeStart))
            .filter(slot => slot.timeStart !== '' && slot.timeStart !== null && slot.timeStart !== undefined),
        tuesday: from.tuesday
            .toSorted((a, b) => a.timeStart.localeCompare(b.timeStart))
            .filter(slot => slot.timeStart !== '' && slot.timeStart !== null && slot.timeStart !== undefined),
        wednesday: from.wednesday
            .toSorted((a, b) => a.timeStart.localeCompare(b.timeStart))
            .filter(slot => slot.timeStart !== '' && slot.timeStart !== null && slot.timeStart !== undefined),
        thursday: from.thursday
            .toSorted((a, b) => a.timeStart.localeCompare(b.timeStart))
            .filter(slot => slot.timeStart !== '' && slot.timeStart !== null && slot.timeStart !== undefined),
        friday: from.friday
            .toSorted((a, b) => a.timeStart.localeCompare(b.timeStart))
            .filter(slot => slot.timeStart !== '' && slot.timeStart !== null && slot.timeStart !== undefined),
        saturday: from.saturday
            .toSorted((a, b) => a.timeStart.localeCompare(b.timeStart))
            .filter(slot => slot.timeStart !== '' && slot.timeStart !== null && slot.timeStart !== undefined),
        sunday: from.sunday
            .toSorted((a, b) => a.timeStart.localeCompare(b.timeStart))
            .filter(slot => slot.timeStart !== '' && slot.timeStart !== null && slot.timeStart !== undefined),
        exceptions: exceptions
    }
}
